<template>
  <div>
    <b-container class="my-5">
      <b-row align-v="center" align-h="center" align-content="center">
        <b-col class="text-center" sm="11" md="9" lg="7" xl="6">
        <b-row class="text-center">
        <b-col class="text-right"><img src="../assets/images/logo.png" width="100" /></b-col>
        <b-col class="text-left"><img src="../assets/images/natureBasket.jpeg" width="130" /></b-col>
        </b-row>

          <b-card-group deck class="mt-3">
            <b-card
              :class="{ 'page-class page-login': !isDarkMode, 'dark-div text-light': isDarkMode }"
              class="box-shadow2 login-card-lg"
            >
              <h1>Login</h1>
              <p class="text-muted">Sign in to your account</p>
              <login-box />
            </b-card>
          </b-card-group>
          <br />
          &copy; {{ thisYear }}
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LoginBox from '@/components/LoginBox.vue';

export default {
  name: 'Login',
  components: { LoginBox },
  metaInfo: {
    title: 'Login',
    meta: [
      {
        name: 'description',
        content: 'Login backend with your account.'
      }
    ]
  },
  mounted() {
    if (this.$route.query.messageKey) {
      this.handleAuthMessageKey({ messageKey: this.$route.query.messageKey });
    }
  },
  methods: {
    ...mapActions('auth', ['handleAuthMessageKey'])
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    thisYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.login-card-lg {
  padding: 1.5rem 1.25rem;
}
</style>
